var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  d: "m1 .728 9 9m0-9-9 9"
})));
export { SvgX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMSAxMSIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZD0iTTEgMC43Mjc5MDVMMTAgOS43Mjc4OCIgc3Ryb2tlPSJibGFjayIvPgogIDxwYXRoIGQ9Ik0xMCAwLjcyNzkwNUwxIDkuNzI3ODgiIHN0cm9rZT0iYmxhY2siLz4KPC9zdmc+";